import * as pubsub from "pubsub-js";
import { ExchangeEmailId } from "client/Api/Email/common";

type EmailIdWithIsReadStatus = {
	emailId: ExchangeEmailId;
	isRead: boolean;
};

export type EmailIdWithIsFlaggedStatus = {
	emailId: ExchangeEmailId;
	isFlagged: boolean;
};

enum EmailEvents {
	emailsDeleted = "email.emailEvents.emailsDeleted",
	emailReadStatusChanged = "email.emailEvents.emailReadStatusChanged",
	emailFlagStatusChanged = "email.emailEvents.emailFlagStatusChanged"
}

type Data<T extends EmailEvents> =
	T extends EmailEvents.emailsDeleted ? { emails: readonly EmailIdWithIsReadStatus[]; isDraft: boolean; } :
	T extends EmailEvents.emailReadStatusChanged ? EmailIdWithIsReadStatus :
	T extends EmailEvents.emailFlagStatusChanged ? EmailIdWithIsFlaggedStatus :
	never;

export const subscribe: <T extends EmailEvents>(kind: T, callback: (message: string, data: Data<T>) => void) => PubSubSubscriptionToken = pubsub.subscribe;
export const publish: <T extends EmailEvents>(kind: T, data: Data<T>) => void = pubsub.publish;
export const unsubscribe: (token: PubSubSubscriptionToken) => void = pubsub.unsubscribe;
export {
	EmailEvents,
	type EmailIdWithIsReadStatus
};

